import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-terms-giveone',
  templateUrl: './terms-giveone.component.html',
  styleUrls: ['./terms-giveone.component.sass']
})
export class TermsGiveoneComponent implements OnInit {

  constructor(public matDialogRef:MatDialogRef<TermsGiveoneComponent>,@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }
  public close(){;
    this.matDialogRef.close('cancel');
  }
}
